import React, { useEffect, useState } from 'react';
import { InputProps as ChakraInputProps } from '@chakra-ui/react';
import { FieldError, UseFormRegister } from 'react-hook-form';
import { Input } from '~/components/Input';
import { formatDecimal } from '~/utils/formatDecimal';

interface InputFloatProps extends ChakraInputProps {
  name: string;
  label?: string;
  error?: FieldError;
  register?: UseFormRegister<any>;
  autocomplete?: string;
  isRequired?: boolean;
  isDisabled?: boolean;
  onChangeValue?: (e: number) => void;
  value?: number;
  decimalPlaces?: number;
}

export const InputFloat: React.VFC<InputFloatProps> = ({
  name,
  label,
  register = () => ({}),
  error = undefined,
  isRequired = false,
  isDisabled = false,
  onChangeValue = undefined,
  value = 0,
  decimalPlaces = 2,
  ...props
}) => {
  const parse = (valueAsString: string) => {
    let valueAsNumber = 0;
    try {
      let parsedValueAsString = valueAsString.replace(/\D/g, '');
      parsedValueAsString = parsedValueAsString.padStart(
        decimalPlaces + 1,
        '0',
      );
      parsedValueAsString = `${parsedValueAsString.substring(
        0,
        parsedValueAsString.length - decimalPlaces,
      )}.${parsedValueAsString.slice(decimalPlaces * -1)}`;
      valueAsNumber = parseFloat(parsedValueAsString);
    } catch {
      valueAsNumber = 0;
    }
    return valueAsNumber;
  };

  const [valor, setValor] = useState<number>(value);
  const [valorFormatado, setValorFormatado] = React.useState(
    formatDecimal(valor, decimalPlaces),
  );

  useEffect(() => {
    if (value !== valor) {
      setValor(value);
      setValorFormatado(formatDecimal(value, decimalPlaces));
    }
  }, [value]);

  function handleValor(e: React.FormEvent<HTMLInputElement>) {
    const v = parse(e.currentTarget.value);
    setValor(v);
    setValorFormatado(formatDecimal(v, decimalPlaces));
    if (onChangeValue) {
      onChangeValue(v);
    }
  }
  return (
    <Input
      label={label}
      isRequired={isRequired}
      name="valor"
      resize="none"
      error={error}
      value={valorFormatado}
      onChange={e => handleValor(e)}
      textAlign="end"
      isDisabled={isDisabled}
      {...props}
    />
  );
};
